<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },
  data() {
    return {
      month_year: "", // se já tiver em outro lugar, pode remover daqui
      selectedReport: "adesoes", // adesoes | boletospagos | inadimplencia | ticketmedio
      ranking: {
        adesoes: { list: null, title: "Adesões" },
        boletospagos: { list: null, title: "Boletos Pagos" },
        inadimplencia: { list: null, title: "Inadimplência – 1º Boleto" },
        ticketmedio: { list: null, title: "Ticket Médio Top 50" },
      },
      loading: false,
    };
  },
  computed: {
    currentList() {
      return this.ranking[this.selectedReport]?.list;
    },
    currentTitle() {
      return this.ranking[this.selectedReport]?.title || "";
    },
  },
  methods: {
    async loadReport(type) {
      // evita chamadas repetidas
      if (!type || this.ranking[type].list !== null) return;

      this.loading = true;
      try {
        const endpoints = {
          adesoes: "apvs/brasil/rankings/adesoes",
          boletospagos: "apvs/brasil/rankings/boletospagos",
          inadimplencia: "apvs/brasil/rankings/inadimplencia",
          ticketmedio: "apvs/brasil/rankings/ticketmedio",
        };
        const url = endpoints[type];
        const response = await api.get(url);
        if (response?.data?.status === "success") {
          this.ranking[type].list = response.data.list || [];
        } else {
          this.ranking[type].list = [];
        }
      } catch (e) {
        console.error(e);
        this.ranking[type].list = [];
      } finally {
        this.loading = false;
      }
    },
    onChangeReport() {
      this.loadReport(this.selectedReport);
    },
  },
  mounted() {
    // carrega o relatório inicial
    this.loadReport(this.selectedReport);
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"/>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">APVS Brasil</li>
      <li class="breadcrumb-item d-none d-sm-block">Rankings</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Rankings</h3>
        <p></p>
      </div>
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0">Relatório:</label>
        <select v-model="selectedReport" class="form-control" @change="onChangeReport">
          <option value="adesoes">Adesões</option>
          <option value="boletospagos">Boletos Pagos</option>
          <option value="inadimplencia">Inadimplência – 1º Boleto</option>
          <option value="ticketmedio">Ticket Médio Top 50</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>{{ currentTitle }} <sup class="font-weight-light">{{ month_year }}</sup></legend>

          <div v-if="loading || currentList === null" class="text-center">
            <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
          </div>

          <div v-else>
            <div
              v-if="currentList.length === 0"
              class="text-muted small"
            >
              Nenhum dado para exibir.
            </div>

            <div
              v-else
              class="d-flex flex-gap-10 justify-content-between align-items-center mb-2"
              v-for="(row, index) in currentList"
              :key="index"
            >
              <div class="d-flex flex-gap-10 align-items-center">
                <span class="ranking-bullet">{{ index + 1 }}</span>
                <span>{{ row.name }}</span>
              </div>
              <!-- Exemplo: se houver métrica numérica (opcional)
              <strong>{{ row.value }}</strong>
              -->
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.ranking-bullet {
  background: var(--st-brand);
  border-radius: 100%;
  padding: 2px;
  width: 25px;
  height: 25px;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
</style>
